import clsx from "clsx";
import { toolTipProps } from "../shared/ToolTip";
import style from "./LegalToolTip.module.css";

export default function LegalToolTip({ title, content }: toolTipProps) {
  return (
    <div className="relative flex flex-col sm:items-center group ">
      <div
        className={clsx(
          "md:absolute relative bottom-1 flex md:flex-col flex-row items-center hidden mb-6 group-hover:flex"
        )}
      >
        <span className={clsx("tooltip-box shadow-lg", style.tooltipBox)}>
          <p className="sub-heading">{content}</p>
        </span>
        <div
          className={clsx(
            "w-3 h-3 z-10 -mt-2 rotate-45 max-sm:hidden tooltip-pointer shadow-lg opacity-100",
            style.tooltipPointer
          )}
        ></div>
      </div>
      <div className="mt-1">
        <img
          src="assets/tooltip-icon.svg"
          alt="tooltip"
          width={15}
          height={15}
          className={clsx("", style.legalInfo)}
        />
      </div>
    </div>
  );
}
